import React, {useMemo} from 'react'
import styles from './UIGameTimer.module.scss'
import clsx from 'clsx'
import {Timer} from '../../common/Timer/Timer.tsx'
import {useGameTimer} from '../../hooks/useGameTimer.ts'
import {useTimerLowTime} from '../../hooks/useTimerLowTime.ts'
import {useGameStore} from '../../store/GameStoreContext.ts'
import {ModeSettingEnum} from '@colonist/types'
import {useCurrentStateValidator} from '../../store/selectors/useCurrentStateValidator.ts'
import {ActionState} from '@colonist/game-states'
import {RED_TIMER_AND_TICKING_SOUND_THRESHOLD} from '@colonist/utils'

export interface UIGameTimerProps {
    timeLeftInSeconds: number
    isMyPlayerTakingAction: boolean
    isPaused: boolean
    className?: string | undefined
}

export function UIGameTimer({
    timeLeftInSeconds,
    isMyPlayerTakingAction,
    isPaused,
    className,
}: UIGameTimerProps) {
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)
    const isBeginnerMode = modeSetting == ModeSettingEnum.BeginnerModeClassic4P
    const isColonistRush = modeSetting == ModeSettingEnum.ColonistRush4P

    const liveTimeLeftInSeconds = useGameTimer({
        timeLeftInSeconds: timeLeftInSeconds,
        isPaused: isPaused,
    })

    const currentStateValidator = useCurrentStateValidator()
    const myColor = useGameStore((state) => state.myColor)

    const isRedAndTicking = useMemo(() => {
        const isTimerInLastSeconds = liveTimeLeftInSeconds <= RED_TIMER_AND_TICKING_SOUND_THRESHOLD
        if(!isTimerInLastSeconds) return false

        if(!isMyPlayerTakingAction) return false

        const isPlayerAlsoPlayingNextTurn = isColonistRush
        const isMyPlayerActionStateNone = currentStateValidator.getPlayerActionState(myColor) == ActionState.None
        if(isPlayerAlsoPlayingNextTurn && isMyPlayerActionStateNone) return false

        return true
    }, [isMyPlayerTakingAction, liveTimeLeftInSeconds, currentStateValidator, myColor])

    useTimerLowTime(liveTimeLeftInSeconds, isRedAndTicking)

    return <div className={clsx(styles.container, className, {
        [styles.hidden]: isBeginnerMode,
    })}>
        <Timer
            className={clsx({
                [styles.red]: isRedAndTicking,
            })}
            timeLeftInSeconds={liveTimeLeftInSeconds}
        />
    </div>
}
